import { getCookie } from "@directv-digital/dds.services.cookie-service";
import getConfig from 'next/config';

function disableLogs(): void {
  console.log = () => {
    Promise.resolve()
  };
  console.debug = () => {
    Promise.resolve()
  };
  console.warn = () => {
    Promise.resolve()
  };
  console.info = () => {
    Promise.resolve()
  };
  console.error = () => {
    Promise.resolve()
  };
}

export function suppressConsoleMethods(): void {
  const { publicRuntimeConfig } = getConfig();

  if (typeof window !== "undefined") {
    const cookieValue = getCookie("dtv-allow-console") || "";
    if (
      process.env.NODE_ENV === "production" && publicRuntimeConfig?.local === "prod" &&
      !(
        /dev\d+/.test(window?.location?.hostname) ||
        /test\d+/.test(window?.location?.hostname) ||
        /stage/.test(window?.location?.hostname)
      ) && cookieValue.trim() !== "on"
    ) {
      disableLogs();
    }
  }
}

/**
 * ENHANCEMENT: Use a custom logger. Run a replace on all console.logs in UF/VL codebase.
 */
// export class Logger {
//   private static env: nextEnv;
//   private static nodeEnv: nodeEnvType;
//   private static logCookie: boolean;

//   readonly log!: (message?: unknown, ...params: unknown[]) => void;
//   readonly debug!: (message?: unknown, ...params: unknown[]) => void;
//   readonly warn!: (message?: unknown, ...params: unknown[]) => void;
//   readonly info!: (message?: unknown, ...params: unknown[]) => void;
//   readonly error!: (message?: unknown, ...params: unknown[]) => void;

//   constructor(nextEnv?: nextEnv) {
//     Logger.nodeEnv = process?.env?.NODE_ENV || "development" as nodeEnvType;
//     Logger.env = nextEnv as nextEnv;
//     Logger.logCookie =
//       typeof window !== 'undefined' && window?.location?.hostname
//         ? (getCookie("dtv-allow-console") || "") === "true" : false;

//     switch(nextEnv) {
//       case "prod":
//         this.log = Logger.logCookie ? console.log.bind(console) : () => {Promise.resolve()};
//         this.debug = Logger.logCookie ? console.debug.bind(console) : () => {Promise.resolve()};
//         this.warn = Logger.logCookie ? console.warn.bind(console) : () => {Promise.resolve()};
//         this.info = Logger.logCookie ? console.info.bind(console) : () => {Promise.resolve()};
//         this.error = Logger.logCookie ? console.error.bind(console) : () => {Promise.resolve()};
//         break;

//       case "stage":
//         this.log = console.log.bind(console);
//         this.debug = console.debug.bind(console);
//         this.warn = Logger.logCookie ? console.warn.bind(console) : () => {Promise.resolve()};
//         this.info = console.info.bind(console);
//         this.error = console.error.bind(console);
//         break;

//       default: // case "local" || "test":
//         this.log = console.log.bind(console);
//         this.debug = console.debug.bind(console);
//         this.warn = console.warn.bind(console);
//         this.info = console.info.bind(console);
//         this.error = console.error.bind(console);
//         break;
//     }
//   }
// }

// const { publicRuntimeConfig } = getConfig();

// export const dtvLogger = new Logger(publicRuntimeConfig?.local || 'prod');

export default suppressConsoleMethods;
